import { render, staticRenderFns } from "./MemberBenefits.vue?vue&type=template&id=58eedc1a&scoped=true"
import script from "./MemberBenefits.vue?vue&type=script&lang=ts"
export * from "./MemberBenefits.vue?vue&type=script&lang=ts"
import style0 from "./MemberBenefits.vue?vue&type=style&index=0&id=58eedc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eedc1a",
  null
  
)

export default component.exports